var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",staticClass:"ds-section",class:[
    _vm.fullheight && "ds-section-fullheight",
    _vm.primary && "ds-section-primary",
    _vm.secondary && "ds-section-secondary",
    _vm.centered && "ds-section-centered"
  ]},[_c('div',{staticClass:"ds-section-content"},[_c('ds-container',[_vm._t("default")],2)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }